"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'userGroup.form.title.edit': 'Modifica Gruppo di Utenti',
    'userGroup.form.title.add': 'Aggiungi Gruppo di Utenti',
    'userGroup.form.back': 'Indietro',
    'userGroup.form.name.label': 'Nome Gruppo',
    'userGroup.form.name.placeholder': 'Inserisci nome gruppo',
    'userGroup.form.description.label': 'Descrizione',
    'userGroup.form.description.placeholder': 'Inserisci descrizione gruppo',
    'userGroup.form.active.label': 'Attivo',
    'userGroup.form.acl.label': 'Controllo Accessi',
    'userGroup.form.acl.description': 'Configura i permessi di accesso per questo gruppo di utenti',
    'userGroup.form.submit.update': 'Aggiorna Gruppo di Utenti',
    'userGroup.form.submit.create': 'Crea Gruppo di Utenti',
    'userGroup.form.saved': 'Gruppo di utenti salvato con successo',
    'userGroup.form.error.save': 'Errore nel salvare il gruppo di utenti',
};
